import { UtilityFunctions } from './../shared/utility-functions';
export class BaseGroup {
    constructor() {

    }
    protected vendor;
    protected clubName = '';
    protected searchMember = '';
    protected popUpMessage: string;
    protected memberList = [];
    protected filterPara = '';
    protected facilityList = [];
    protected preferenceList = [];
    protected facilityFilter = [];
    protected preferenceFilter = [];
    protected selectItem = false;
    protected filterState = '';
    protected allFilter = true;
    protected showFilterFacility = false;
    protected showFilterPreference = false;
    protected groupList = [];
    protected filterStateSubMenuList = [];
    protected selectGroup = {
        _id: '',
        name: ''
    };
    protected currentGroupId = '';
    protected selectGroupId = '';
    protected selectGroupName = '';
    protected recentCreatedGroup = '';
    protected isGroupDisable: boolean = false;
    protected message = '';
    protected utilityFunctions = new UtilityFunctions();
    /**
    * Add facility to filter by disable group
    */
    /**
       * Add facility to filter by preference
       */

    addPreferencesForFilter(that, e, facilityId) {
        try {
            if (e.target.checked) {
                that.preferenceFilter.push(facilityId);
            } else {
                that.preferenceFilter.splice(that.preferenceFilter.indexOf(facilityId), 1);
            }
        } catch (e) {
            console.log(e);
        }
    }
    addFacilityForFilter(that, e, facilityId) {
        try {
            if (e.target.checked) {
                that.facilityFilter.push(facilityId);
            } else {
                that.facilityFilter.splice(that.facilityFilter.indexOf(facilityId), 1);
            }
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Select criteria for filter
     */
    selectCriteriaForFilter(that, para) {
        try {
            that.filterPara = para;
            switch (that.filterPara) {
                case 'Inactive':
                    that.facilityList = this.utilityFunctions.makeListUnCheck(that.facilityList);
                    that.preferenceList = this.utilityFunctions.makeListUnCheck(that.preferenceList);
                    that.facilityFilter = [];
                    that.preferenceFilter = [];
                    break;
                case 'DisabledFacility':
                    that.preferenceList = this.utilityFunctions.makeListUnCheck(that.preferenceList);
                    that.preferenceFilter = [];
                    break;
                case 'Prefernces':
                    that.facilityList = this.utilityFunctions.makeListUnCheck(that.facilityList);
                    that.facilityFilter = [];
                    break;
                default:
                    that.facilityList = this.utilityFunctions.makeListUnCheck(that.facilityList);
                    that.preferenceList = this.utilityFunctions.makeListUnCheck(that.preferenceList);
                    that.facilityFilter = [];
                    that.preferenceFilter = [];
                    break;
            }
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Maintain the filter set
     * 
     * @param {any} that 
     * 
     * @memberof BaseGroup
     */
    maintainFilterState(that) {
        that.selectItem = false;
        that.filterPara = that.filterState;
        that.allFilter = false;
        that.showFilterFacility = false;
        that.showFilterPreference = false;
        that.facilityList = this.utilityFunctions.makeListUnCheck(that.facilityList);
        that.groupList = this.utilityFunctions.makeListUnCheck(that.groupList);
        that.preferenceList = this.utilityFunctions.makeListUnCheck(that.preferenceList);
        switch (that.filterState) {
            case 'Inactive':
                that.selectItem = true;
                that.facilityFilter = [];
                that.preferenceFilter = [];
                break;
            case 'DisabledFacility':
                that.facilityFilter = [];
                if (that.filterStateSubMenuList.length > 0) {
                    for (let fac of that.filterStateSubMenuList) {
                        for (let rec of that.facilityList) {
                            if (fac === rec._id) {
                                rec.isChecked = true;
                                that.facilityFilter.push(rec._id);
                                break;
                            }
                        }
                        that.showFilterFacility = true;
                    }
                } else {
                    that.showFilterFacility = false;
                    that.allFilter = true;
                }
                that.preferenceFilter = [];
                break;
            case 'Prefernces':
                that.preferenceFilter = [];
                if (that.filterStateSubMenuList.length > 0) {
                    for (let fac of that.filterStateSubMenuList) {
                        for (let rec of that.preferenceList) {
                            if (fac === rec._id) {
                                rec.isChecked = true;
                                that.preferenceFilter.push(rec._id);
                                break;
                            }
                        }
                        that.showFilterPreference = true;
                    }
                } else {
                    that.showFilterPreference = false;
                    that.allFilter = true;
                }
                that.facilityFilter = [];
                break;
            default:
                that.allFilter = true;
                that.facilityFilter = [];
                that.preferenceFilter = [];
                that.filterStateSubMenuList = [];
                break;
        }
    }
    /**
     * Get facility list for filter
     * 
     * @param {any} that 
     * 
     * @memberof BaseGroup
     */
    getFacilityListForFilter(that) {
        that.appService.getFacilityList(that.vendor._id).then((result: any) => {
            if (result.status === 'SUCCESS') {
                that.facilityList = result.facilityData;
                that.preferenceList = JSON.parse(JSON.stringify(this.facilityList));
            }
        }).catch((err) => {
            that.popUpMessage = err;
            that.loaderEvent.fire(true);
        });
    }
    /**
     * API call for edit group name
     * 
     * @param {any} that 
     * @param {any} group 
     * 
     * @memberof BaseGroup
     */
    changeName(that, group) {
        let request = {
            vendorId: that.vendor._id,
            groupId: that.selectGroupId,
            newName: (group.groupName + '').trim(),
            'description': (group.description + '').trim()
        };
        let tempGroupId = that.selectGroupId;
        that.groupService.updateGroupName(request).then((result: any) => {
            if (result.status === 'SUCCESS') {
                let vendorObj = { vendorId: that.vendor._id };
                localStorage.setItem('recentCreatedGroupId', btoa(JSON.stringify(that.selectGroupId)));
                that.getGroupList();
                that.pagination(that.pageOptions, 1, that.selectGroupId);
            }
        });
        that.actionable = false;
    }

    /**
     * Delete group
     */
    deleteGroup(that, bool: any, popupObj) {
        try {
            if (bool) {
                let deleteGroupObj = {
                    'groupId': that.selectGroupId
                };
                that.loaderEvent.fire(false);
                that.groupService.deleteGroup(deleteGroupObj).then((result: any) => {
                    if (result.status === 'SUCCESS') {
                    }
                    that.popUpMessage = result.message;
                    popupObj.showChildModal();
                    that.loaderEvent.fire(true);
                    that.actionable = false;
                });
            }
        } catch (e) {

        }
    }
}


// WEBPACK FOOTER //
// ./src/app/group/base-group.ts